// extracted by mini-css-extract-plugin
export default {"Modal":"_69xpAMdVnM7J0reHIkLL","Content":"WunOg2OE9zFjW5fcFpkz","HeadCenter":"xpqInWtagoCaks9XHwkA","HeadClose":"PneyEHH73ZiYSbPDMoOA","BtnGroup1":"Sh2d6DI3HGWweZoHn8jG","Button":"QeM10pw83n7K3MBgNDFA","BtnGroup":"oKSYQtH2LbQ9pafM2VCD","table__row":"Cp29JVnajD6k5Hj3Oby8","table__item":"MwEex_cMIISYB0J5PYDi","item":"Rzm1Gq7WgWBVoiWnXUBP","animcheck":"jxZ73DgT9rODPPnsLbkz","animinput":"xyvcSh6S9C8eOxKiDmP8","animlabel":"RSdVByVjBZx3kWKGEsyE","animicon":"a6ePv9i1tugdFicaujwp"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"Modal\":\"_69xpAMdVnM7J0reHIkLL\",\"Content\":\"WunOg2OE9zFjW5fcFpkz\",\"HeadCenter\":\"xpqInWtagoCaks9XHwkA\",\"HeadClose\":\"PneyEHH73ZiYSbPDMoOA\",\"BtnGroup1\":\"Sh2d6DI3HGWweZoHn8jG\",\"Button\":\"QeM10pw83n7K3MBgNDFA\",\"BtnGroup\":\"oKSYQtH2LbQ9pafM2VCD\",\"table__row\":\"Cp29JVnajD6k5Hj3Oby8\",\"table__item\":\"MwEex_cMIISYB0J5PYDi\",\"item\":\"Rzm1Gq7WgWBVoiWnXUBP\",\"animcheck\":\"jxZ73DgT9rODPPnsLbkz\",\"animinput\":\"xyvcSh6S9C8eOxKiDmP8\",\"animlabel\":\"RSdVByVjBZx3kWKGEsyE\",\"animicon\":\"a6ePv9i1tugdFicaujwp\"}";
        // 1791380110845
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  